export const GetSpotWalletInfo = "/SpotWallet/GetSpotWalletInfo";
export const GetMarginWalletInfo = "/MarginWallet/GetMarginWalletInfo";

export const GetPortfolioChart = ({ walletTypeId }) =>
  `/Portfolio/GetPortfolioChart?WalletTypeId=${walletTypeId}`;

export const GetSpotWalletList = ({ isShowMore }) =>
  `/SpotWallet/GetSpotWalletList?IsShowMore=${isShowMore}`;
export const GetMarginWalletList = ({ isShowMore }) =>
  `/MarginWallet/GetMarginWalletList?IsShowMore=${isShowMore}`;

export const GetHistoryCryptoForm = "/Request/GetHistoryCryptoForm";
export const GetHistoryFiatForm = "/Request/GetHistoryFiatForm";

export const GetHistoryFiatList = ({
  coinId,
  startDate,
  endDate,
  sideId,
  pageNumber,
  pageSize,
}) =>
  `/Request/GetHistoryFiatList?TypeId=0&CoinId=${coinId}&StartDate=${startDate}&EndDate=${endDate}&SideId=${sideId}&StateId=0&PageNumber=${pageNumber}&PageSize=${pageSize}`;

export const GetHistoryCryptoList = ({
  coinId,
  startDate,
  endDate,
  sideId,
  pageNumber,
  pageSize,
}) =>
  `/Request/GetHistoryCryptoList?TypeId=0&CoinId=${coinId}&StartDate=${startDate}&EndDate=${endDate}&SideId=${sideId}&StateId=0&PageNumber=${pageNumber}&PageSize=${pageSize}`;



export const GetHistoryCrypto = (id) => `/Request/GetHistoryCrypto?Id=${id}`;

export const GetHistoryFiat = (id) => `/Request/GetHistoryFiat?Id=${id}`;

export const GetSpotTransferHistoryForm = `/SpotWallet/GetSpotTransferHistoryForm`;

export const GetSpotTransferHistoryList = ({
  coinId,
  typeTransferId,
  startDate,
  endDate,
  pageNumber,
  pageSize,
}) =>
  `/SpotWallet/GetSpotTransferHistoryList?CoinId=${coinId}&typeTransferId=${typeTransferId}&StartDate=${startDate}&EndDate=${endDate}&PageNumber=${pageNumber}&PageSize=${pageSize}`;